import React from 'react';
import { styled } from '@mui/material/styles';
import { List, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CheckMarkListItem } from '@lialo/pwa-ui/lib/BulletList';
import { range } from '@lialo/common/lib/array';

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  padding: theme.spacing(2, 0, 1, 1),
}));

interface IProps {
  title: string;
}

const WhatToExpectList = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledTypography variant={'subtitle2'}>{props.title}</StyledTypography>
      <List disablePadding>
        {range(1, 7).map(i => (
          <CheckMarkListItem key={i} title={t(`tour_detail.what_to_expect.description_${i}`)} />
        ))}
      </List>
    </>
  );
};

export default WhatToExpectList;
